export default __webpack_public_path__ + "static/media/filter-details-tabs.128e60e7.gif";